<template>
  <div class="product-page">
    <div class="main-container header-section">
      <div class="header-top">
        <h1 class="brand-title">PRODUCT CENTER</h1>
      </div>
      <div class="filter-bar">
        <el-checkbox-group v-model="selectedCategories" @change="handleFilterChange">
          <el-checkbox label="" class="custom-checkbox">ALL</el-checkbox>
        </el-checkbox-group>
      </div>
    </div>

    <div class="main-container main_null" v-show="total == 0">PLEASE CONTINUE BROWSING</div>

    <div class="main-container" v-if="total > 0">
      <el-row :gutter="30">
        <el-col v-for="(item, index) in products" :key="index" :xs="12" :sm="12" :md="8" :lg="6" class="grid-col">
          <div class="product-card">
            <!-- 图片展示区域 -->
            <!-- 情况A：无多图列表，显示单张封面 -->
            <div class="image-wrapper"
              v-if="!item.companyProductImagePojoList || item.companyProductImagePojoList.length === 0">
              <img :src="imageUtils(websiteImg, item.cover)" alt="Product Image" class="product-img">
            </div>

            <!-- 情况B：有多图，开启自动轮播 -->
            <div class="image-wrapper" v-else>
              <el-carousel :ref="'carousel_' + index" :height="carouselHeight" arrow="never" indicator-position="none"
                :autoplay="true" :interval="3000" @change="(val) => handleCarouselChange(val, item)">
                <el-carousel-item v-for="(val, inx) in item.companyProductImagePojoList" :key="inx">
                  <img :src="imageUtils(websiteImg, val.fileName)" alt="Product Image" class="product-img">
                </el-carousel-item>
              </el-carousel>
            </div>

            <!-- 下方色块（指示器） -->
            <div class="color-swatches"
              v-if="item.companyProductImagePojoList && item.companyProductImagePojoList.length > 0">
              <div v-for="(val, inx) in item.companyProductImagePojoList" :key="inx" class="swatch-item"
                :class="{ active: item.activeColorIdx === inx }" @click.stop="manualSwitch(index, inx)"  v-show="screenWidth <=  768 ? inx < 4 :true">
                <img :src="imageUtils(websiteImg, val.fileName)" v-show="inx < 3 || screenWidth > 768">
                  <span v-show="inx ==3 && item.companyProductImagePojoList.length > 3 && screenWidth <= 768" style="font-size: 7rem;"> ...</span>
              </div>
            </div>

            <div class="color-swatches" v-else>
              <div class="swatch-item active">
                <img :src="imageUtils(websiteImg, item.cover)">
              </div>
            </div>

            <!-- 信息区域 -->
            <div class="info-wrapper">
              <h3 class="product-name" style="margin-bottom: 15px;">{{ item.productName }}</h3>
              <el-button class="add-cart-btn" type="primary" @click="getProductDetails(item.cpId)">
                ADD TO CART
              </el-button>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <!-- 分页 -->
    <div class="pagination-section" v-if="total > 0">
      <el-pagination layout="prev, pager, next, slot" :total="total" :current-page.sync="formData.pageNo"
        prev-text="< Previous" next-text="Next >" @current-change="getList">
      </el-pagination>
    </div>

    <!-- 抽屉 -->
    <el-drawer :visible.sync="drawer" :direction="'rtl'" :before-close="handleClose" :append-to-body="true"
      :show-close="true" :size="screenWidth < 768 ? '100%' : '600px'" custom-class="product-drawer">
      <div class="drawer-container">
        <h3 class="drawer-title">ADD TO CART</h3>
        <div class="product-summary">
          <div class="summary-img">
            <img :src="imageUtils(websiteImg, currentProduct.image)" alt="Product">
          </div>
          <div class="summary-info">
            <div class="p-name">{{ fabrics.productName }}</div>
            <div style="height: 60%;">
              <div v-if="fabrics.croductLabelList && fabrics.croductLabelList.length > 0">
                <span v-for="(v, i) in fabrics.croductLabelList" :key="i" class="summary—tab">{{ v.labelContent }}</span>
              </div>
            </div>
            <div class="p-name"> {{ fabrics.productPrice ? 'From $ ' + fabrics.productPrice : "" }}</div>
          </div>
        </div>

        <div class="fabric-section">
          <div class="section-label">FABRIC</div>
          <div class="fabric-grid">
            <div v-for="(fItem, fIndex) in fabrics.productColorList" :key="fIndex" class="fabric-item"
              :class="{ 'is-selected': selectedFabricId == fItem.pcId }" @click="selectFabric(fItem)">
              <div class="img-box">
                <el-tooltip class="item" effect="dark" placement="bottom" popper-class="custom-tooltip" :disabled="screenWidth < 768">
                  <div slot="content">
                    <div class="tooltip-img"><img :src="imageUtils(websiteImg, fItem.cover)" /></div>
                    <div class="lineBreak">{{ fItem.colorContent }}</div>
                  </div>
                  <img :src="imageUtils(websiteImg, fItem.cover)" />
                </el-tooltip>
              </div>
              <div class="fabric-name">{{ fItem.colorContent }}</div>
            </div>
          </div>
        </div>

        <div class="drawer-footer">
          <el-button class="add-cart-btn" type="primary" style="margin-bottom: 15px;" @click="handleAddToCart">
            CONFIRM
          </el-button>
          <div class="btn-cancel" @click="handleClose">CANCEL</div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import "@/style/productCenter.scss";
import { companyProductPojoList, companyProductPojoDetails, addProductShoppingCart } from "@/api/member";
import { imageUtils } from '@/utils/imageUtil';
import utils from '@/utils/util.js';
import { mapGetters } from "vuex";

export default {
  name: "ProductCenter",
  data() {
    return {
      websiteImg: utils.websiteImg,
      total: 0,
      formData: { pageNo: 1, pageSize: 12, type: '' },
      products: [],
      selectedCategories: [''],
      drawer: false,
      selectedFabricId: '',
      currentProduct: {},
      fabrics: [],
      isAddingToCart: false,
      carouselHeight: '300px',
    };
  },
  computed: {
     ...mapGetters("app", ["getScreenWidth", "isMobile"]),
        screenWidth() {
            return this.getScreenWidth;
        },
  },
  methods: {
    imageUtils,
    updateCarouselHeight() {
      this.$nextTick(() => {
        // 获取当前列的宽度
        const wrapper = document.querySelector('.image-wrapper');
        if (wrapper) {
          const width = wrapper.offsetWidth;
          // 比如你想保持 1:1 的比例，或者根据原图比例计算
          this.carouselHeight = `${width}px`;
        }
      });
    },
    getList(pageNo) {
      this.formData.pageNo = pageNo || this.formData.pageNo;
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0.8)'
      });

      companyProductPojoList(this.formData).then(res => {
        const list = res.data.dataList || [];
        // 初始化 activeColorIdx 属性以确保响应式
        this.products = list.map(item => ({
          ...item,
          activeColorIdx: 0
        }));
        this.total = res.data.count;
      }).finally(() => {
        setTimeout(() => { loading.close(); }, 200);
      });
    },

    handleCarouselChange(activeIndex, item) {
      this.$set(item, 'activeColorIdx', activeIndex);
    },

    manualSwitch(productIndex, imgIndex) {
      const carouselRef = this.$refs['carousel_' + productIndex];
      if (carouselRef && carouselRef[0]) {
        carouselRef[0].setActiveItem(imgIndex);
      }
    },

    handleAddToCart() {
      if (this.isAddingToCart) return;
      this.isAddingToCart = true;
      addProductShoppingCart({
        cpId: this.currentProduct.cpId,
        pcId: this.selectedFabricId,
      }).then(res => {
        if (res.code == 1) {
          this.$message({ message: 'SUCCESS', type: 'success' });
          this.handleClose();
          this.$eventBus.$emit('updateCartCount');
          this.$router.push('/member/cart')
        } else {
          this.$message({ message: res.data.message || 'error', type: 'error' });
        }
      }).finally(() => {
        this.isAddingToCart = false;
      });
    },

    handleResize() {
      this.screenWidth = document.documentElement.clientWidth || window.innerWidth;
    },

    handleClose() {
      this.drawer = false;
    },

    selectFabric(data) {
      this.selectedFabricId = data.pcId;
      this.currentProduct = data;
    },

    async getProductDetails(id) {
      await companyProductPojoDetails({ cpId: id }).then(res => {
        const details = res.data.dataDetails;
        if (details.productColorList && details.productColorList.length > 0) {
          this.drawer = true;
          this.fabrics = details;
          this.currentProduct = details.productColorList[0];
          this.selectedFabricId = details.productColorList[0].pcId;
        } else {
          this.$message({ message: 'Please contact customer service', type: 'error' });
        }
      });
    },

    handleFilterChange(val) {
      if (val.length > 1) {
        this.selectedCategories = [val[val.length - 1]];
      } else if (val.length === 0) {
        this.selectedCategories = [''];
      }
      this.formData.type = this.selectedCategories[0] || '';
      this.getList(1);
    }
  },
  activated() {
    this.getList();
  },
  mounted() {
    this.updateCarouselHeight();
    window.addEventListener('resize', this.updateCarouselHeight);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateCarouselHeight);
  }
};
</script>

<style scoped>
::v-deep .el-drawer__header {
  margin-bottom: 0 !important;
}

.custom-tooltip {
  background: rgba(43, 35, 30, .8) !important;
}
</style>

<style lang="scss" scoped>
.pagination-section {
  text-align: center;
  margin-top: 60px;

  ::v-deep .el-pagination {
    font-family: $serif-font;

    .btn-prev,
    .btn-next {
      background-color: transparent;
      color: #666;
    }

    .el-pager li {
      background-color: transparent;
      color: #999;

      &.active {
        color: #000;
        font-weight: bold;
      }

      &:hover {
        color: #000;
      }
    }
  }
}

.color-swatches {
  margin-top: 15px;
  margin-bottom: 30px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;

  .swatch-item {
    width: 30px;
    height: 30px;
    cursor: pointer;
    position: relative;
    transition: all 0.3s ease;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 2px;
    }

    &.active {
      &::after {
        content: '';
        position: absolute;
        bottom: -6px;
        left: 0;
        width: 100%;
        height: 2px;
        background-color: #2B231E;
      }
    }

    &:hover {
      opacity: 0.8;
    }
  }
}

.image-wrapper {
  width: 100%;

  .product-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

::v-deep .el-checkbox__label {
  font-size: 12px;
  color: #999;
  letter-spacing: 1px;
  text-transform: uppercase;
}

::v-deep .el-checkbox__input.is-checked+.el-checkbox__label {
  color: #2B231E;
  font-weight: bold;
}

::v-deep .el-checkbox__inner {
  border-radius: 0;
  /* 方形勾选框 */
  background-color: transparent;
  border-color: #999;
}

::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #2B231E;
  border-color: #2B231E;
}

.product-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  vertical-align: middle;
}

/* 确保轮播图容器本身没有背景色干扰或溢出 */
::v-deep .el-carousel__item {
  overflow: hidden;
  background-color: transparent;
  /* 或者设置为与图片主色调一致 */
}

.product-card {
  display: flex;
  flex-direction: column;
  // background-color: #f5f5f5; /* 确保卡片有底色，即使有微小缝隙也不明显 */
}

.image-wrapper {
  line-height: 0;
  font-size: 0;
}

.color-swatches {
  /* 确保指示器区域紧贴图片 */
  margin-top: 0;
  padding-top: 15px;
  // background-color: #f5f5f5; /* 与图片周围颜色一致 */
}

.summary—tab {
  padding: 5px 15px;
  color: #856B5D;
  background: #F7F3F0;
  margin-right: 10px;
  border-radius: 6px;
  font-size: 14px;
}

/* 响应式调整 */
@media screen and (max-width: 768px) {
  .product-col {
    padding-left: 10px !important;
    padding-right: 10px !important;
  }

  .header-section {
    padding: 40px 0px 20px;
  }

  

  .brand-title,
  .drawer-title,
  .product-name,
  .section-label,
  .fabric-name,
  .main_null
  {
    font-size: 4rem !important;
  }

  .filter-bar,
  .product-name,
   .p-name ,
   .summary—tab {
    font-size: 3rem !important;
  }

  .product-name {
    height: 6rem !important;
    line-height: 6rem !important;
    width: 100% !important;
  }

  .color-swatches {
    padding: 40px 0 !important;
  }

  .swatch-item {
    width: 9rem !important;
    height: 9rem !important;

    /* 选中状态：下方显示黑线 */
    &.active::after {
      bottom: -15px !important;
      height: 5px;
    }
  }

  .add-cart-btn {
    padding: 2rem 2rem;
    font-size: 3rem !important;
  }

  ::v-deep .el-checkbox__label {
    font-size: 4rem !important;
    color: #999;
    letter-spacing: 1px;
    text-transform: uppercase;
  }
  .summary-img{
    width: 400px;
    height: 400px;
  }
  .fabric-name {
    font-size: 3rem !important;
    height: 4rem !important;
    line-height: 4rem !important;
  }
  .p-name{
    margin-bottom: 1rem;
  }
  .summary—tab {
  padding: 1rem 2.5rem;
  box-sizing: border-box;
  margin-right: 10px;
  font-size: 14px;
  margin: 20px 20px 20px 0;
}
}
</style>
